import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

// Retry product photos that failed on a transient network/server hiccup.
window.addEventListener("error", (e) => {
  const img = e.target;
  if (!(img instanceof HTMLImageElement) || !img.src.includes("/api/uploads/")) return;
  const n = Number(img.dataset.retry || 0);
  if (n >= 3) return;
  img.dataset.retry = String(n + 1);
  const src = img.src.replace(/([?&])r=\d+&?/, "$1").replace(/[?&]$/, "");
  setTimeout(() => {
    img.style.visibility = "";
    img.style.display = "";
    img.src = `${src}${src.includes("?") ? "&" : "?"}r=${n + 1}`;
  }, 800 * (n + 1));
}, true);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
